import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Add, FileCopySharp } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { wsGet, wsFindBy } from 'services/WService.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import moment from 'moment';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código de producto', accessor: 'ItemCode' },
  { Header: 'Nombre de producto', accessor: 'ItemName' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function ProductGroupsCloroxDetail(props) {
  const { id } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [group, setGroup] = useState(null);
  const [details, setDetails] = useState([]);

  async function getGroup(idG) {
    setDataLoading(true);
    let response = await wsGet('sale/clorox-group-products', idG);
    setDataLoading(false);
    if (response.success) setGroup(response.data);
  }

  async function loadDetails() {
    setDataLoading(true);
    let response = await wsFindBy('sale/clorox-group-product-details', {
      group_product_id: id,
    });
    setDataLoading(false);
    if (response.success) setDetails(response.data);
  }

  useEffect(() => {
    getGroup(id);
  }, []);

  useEffect(() => {
    if (group?.Periodo) loadDetails();
  }, [group]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={loadDetails}
          id={id}
        />
      ) : null}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Detalle de Grupos de Productos Clorox
              <span style={{ fontSize: '14px' }}>
                <b>{` (${group?.Periodo || ''} - ${group?.description || ''})`}</b>
              </span>
              {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="clorox_producto_grupo_detalle"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={details.map((item, i) => ({
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}>
                      <ButtonDelete
                        entity="sale/clorox-group-product-details"
                        id={item.id}
                        reload={() => {
                          setDataLoading(true);
                          loadDetails().then(() => setDataLoading(false));
                        }}
                      />
                    </AllowedGuard>
                  </div>
                ),
                ItemCode: item.product?.ItemCode,
                ItemName: item.product?.ItemName,
                actions: '',
              }))}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
